/* global translations */
/* global globals */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';
import Select from 'react-select';
import get from 'lodash/get';
import _ from 'lodash';
import cx from '../../utils/cx';
import { Checkbox, Input, Select as Select1 } from '../../components/forms';
import ImageSvg from '../../components/image/ImageSvg';
import SearchParamsStore from '../../stores/SearchParamsStore';
import MembersActionCreators from '../../actions/MembersActionCreators';
import MemberStore from '../../stores/MemberStore';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

class SearchSideContainer extends Component {
  state = {
    questionsData: {},
    params: SearchParamsStore.getSearchParams(),
    additionalQuestionVisibility: {},
    changedParams: false,
  };

  searchForm = React.createRef();

  isMobile = _.get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint;

  componentDidMount() {
    // eslint-disable-next-line no-undef, camelcase
    MembersActionCreators.getSearchableQuestions(questions, additional_questions);

    let questionsData = MemberStore.getQuestionsData();
    SearchParamsStore.setQuestionNames(questionsData);

    MemberStore.addChangeQuestionListener(this.onQuestionChange);

    SearchParamsStore.addChangeParamsListener(this.onParamsChange);
    SearchParamsStore.addChangeParamsSubmitListener(this.onParamsChangeSubmit);
    if (typeof searchParams !== 'undefined') { // eslint-disable-line no-undef
      SearchParamsStore.setAllSearchParams(searchParams); // eslint-disable-line no-undef
      searchParams = undefined; // eslint-disable-line no-undef
    }

    // eslint-disable-next-line no-undef, camelcase
    if (typeof questions !== 'undefined' && typeof additional_questions !== 'undefined') {
      questionsData = MemberStore.getQuestionsData();
    }

    const params = SearchParamsStore.getSearchParams();
    const additionalQuestionVisibility = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value.length && typeof questionsData.additional_questions[key] !== 'undefined') {
        additionalQuestionVisibility[key] = true;
      }
    });

    this.setState({
      params,
      questionsData,
      additionalQuestionVisibility,
    }, () => this.createQuery());
  }

  componentWillUnmount() {
    MemberStore.removeChangeQuestionListener(this.onQuestionChange);

    SearchParamsStore.removeChangeParamsListener(this.onParamsChange);
    SearchParamsStore.removeChangeParamsSubmitListener(this.onParamsChangeSubmit);
  }

  onQuestionChange = () => {
    const questionsData = MemberStore.getQuestionsData();
    SearchParamsStore.setQuestionNames(questionsData);

    this.setState({ questionsData });
  };

  onParamsChange = () => {
    this.setState({
      params: SearchParamsStore.getSearchParams(),
      changedParams: true,
    }, () => this.createQuery());
  };

  onParamsChangeSubmit = () => {
    this.setState({ changedParams: true }, () => this.submitForm());
  };

  // parāda/paslēpj formu
  toggleFormVisibility = () => {
    const { formVisible } = this.state;
    this.setState({ formVisible: !formVisible });
  };

  // paslēpj papildus jautājumu, noņem meklēšanas kritēriju
  setHideAdditionalQuestion = (id) => {
    const { state } = this;
    state.additionalQuestionVisibility[id] = false;
    if (typeof state.params[id] !== 'undefined' && state.params[id].length) {
      state.params[id] = []; // bez paslēpšanas noņemt arī meklēšanas kritēriju
      state.changedParams = true;
      this.setState(state, () => this.props.submitForm(this.createQuery()));
      return;
    }

    this.setState(state, () => this.createQuery());
  };

  toggleVal = (array, value) => SearchParamsStore.toggleVal(array, value);

  handleAgeRangeChange = (data) => {
    const { state } = this;
    state.params.age_min = data.min;
    state.params.age_max = data.max;
    state.changedParams = true;
    this.setState(state, () => this.createQuery());
  };

  handleAgeRangeChangeComplete = () => {
    this.props.submitForm(this.createQuery());
  };

  handleHeightRangeChange = (data) => {
    const { state } = this;
    state.params.height_min = data.min;
    state.params.height_max = data.max;
    state.changedParams = true;
    this.setState(state, () => this.createQuery());
  };

  handleHeightRangeChangeComplete = () => {
    this.props.submitForm(this.createQuery());
  };

  handleCityChange = (event) => {
    const data = {
      type: 'select',
      name: '88',
      value: event.value,
    };
    this.handleChange({ target: data });
  };

  handleChange = (event) => {
    const { state } = this;
    const {
      type,
      name,
      value,
      checked,
    } = event.target;

    if (type === 'checkbox') {
      if (typeof state.params[name] === 'object') {
        state.params[name] = this.toggleVal(state.params[name], value);
      } else {
        state.params[name] = checked;
      }
    }

    if (type !== 'checkbox') {
      const allowedOnlyNumbers = ['age_min', 'age_max', 'height_min', 'height_max'];

      // TODO Šo vēl var pārskatīt.
      // Būtībā.. darbojas.
      if (allowedOnlyNumbers.includes(name)) {
        // Pārbauda, vai vērtība ir vesels skaitlis
        if (/^\d+$/.test(value)) {
          const intValue = parseInt(value, 10);
          // Pārbauda, vai iekļaujas paredzētajā range
          switch (name) {
            case 'age_min':
              state.params[name] = intValue < 18 ? 18 : (intValue > state.params.age_max ? state.params.age_max : intValue); // eslint-disable-line no-nested-ternary, max-len
              break;
            case 'age_max':
              state.params[name] = intValue > 120 ? 120 : (intValue < state.params.age_min ? state.params.age_min : intValue); // eslint-disable-line no-nested-ternary, max-len
              break;
            case 'height_min':
              state.params[name] = intValue < 0 ? 0 : (intValue > state.params.height_max ? state.params.height_max : intValue); // eslint-disable-line no-nested-ternary, max-len
              break;
            case 'height_max':
              state.params[name] = intValue > 220 ? 220 : (intValue < state.params.height_min ? state.params.height_min : intValue); // eslint-disable-line no-nested-ternary, max-len
              break;
            default:
              state.params[name] = intValue;
          }
        } else {
          // Ja ir ievadīti burti, kur jābūt tikai cipariem,
          // iestata defaultās vērtības vai nemaina neko
          switch (name) {
            case 'age_min':
              state.params[name] = 18;
              break;
            case 'age_max':
              state.params[name] = 120;
              break;
            case 'height_min':
              state.params[name] = 0;
              break;
            case 'height_max':
              state.params[name] = 220;
              break;
            default:
              return;
          }
        }
      } else {
        state.params[name] = value;
      }
    }

    // mainot valsti noņemt pilsētu
    if (name === '86') {
      state.params[88] = [];
    }

    state.changedParams = true;

    this.setState(state, () => this.props.submitForm(this.createQuery()));
  };

  // papildus jautājuma vērtība
  handleAdditionalQuestionValueChange = (event) => {
    const { state } = this;
    state.params[event.target.name] = this.toggleVal(this.state.params[event.target.name], event.target.value); // eslint-disable-line max-len
    state.changedParams = true;

    this.setState(state, () => this.props.submitForm(this.createQuery()));
  };

  // parāda papildus jautājumu
  handleAdditionalQuestionChange = (event) => {
    const { state } = this;
    state.additionalQuestionVisibility[event.target.value] = true;
    this.setState(state);
  };

  // izveido query no state
  createQuery = () => {
    const { params } = this.state;
    const esc = encodeURIComponent;
    const query = Object.keys(params).map((key) => {
      const paramValue = esc(params[key]);
      const equal = '=';
      // Lai īsāks/'tīrāks' query/url,
      // pievieno parametru tikai, ja vērtība nav tukšums.
      // Lai neveidojas, piemēram, šādi varianti '...&88=&...'
      // Te izlaiž arī 'page', jo tas tiek pievienots vēlāk.
      if (paramValue && paramValue !== 'page') {
        return esc(key) + equal + paramValue;
      }
      return '';
    }).filter((param) => param !== '').join('&');
    SearchParamsStore.setQuery(query);
    SearchParamsStore.setAllSearchParams(params);
    return query;
  };

  submitForm = (e) => {
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }

    const { changedParams } = this.state;
    const { type } = this.props;
    // ja nav mainīti search parametri un nav saderību sadaļa, nemeklēt vēlreiz
    if (changedParams || type === 'matches') {
      const { submitForm } = this.props;
      submitForm();
    }

    if (type === 'side') {
      this.props.submitSideForm(this.createQuery());
    }
  };

  removeParams = () => {
    const { params } = this.state;

    const defaultParams = SearchParamsStore.getDefaultParams();
    if (JSON.stringify(defaultParams) !== JSON.stringify(params)) {
      this.setState(
        {
          changedParams: false,
          params: defaultParams,
        },
        () => this.props.submitForm(this.createQuery()),
      );
    }
  };

  render() {
    const { params, additionalQuestionVisibility } = this.state;
    const { type, showName, subType } = this.props;

    // dont show anything if mobile and my_likes
    if (this.isMobile && subType === 'my_likes') {
      return null;
    }

    const renderCityQuestion = (question) => {
      const citiesByCountry = {};

      Object.values(question.answers).forEach((answer) => {
        const countryId = answer.country_id.toString();
        if (typeof citiesByCountry[countryId] !== 'undefined') {
          citiesByCountry[countryId].push({
            key: answer._id,
            value: answer._id.toString(),
            label: answer.title,
          });
        } else {
          citiesByCountry[countryId] = [{ value: '', label: '-' }];
        }
      });

      if (typeof params[86] !== 'undefined'
        && typeof citiesByCountry[params[86]] !== 'undefined'
        && citiesByCountry[params[86]].length > 1
      ) {
        const customStyles = {
          menu: (provided) => ({
            ...provided,
            zIndex: '3',
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#008fea' : null,
            color: state.isFocused ? 'white' : null,
            padding: 3,
          }),
        };

        return (
          <div className={`block block--line mts${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`} key={question._id}>
            <div className="searchParams-label">{question.title}</div>
            <div>
              <Select
                styles={customStyles}
                key={question._id}
                id={question._id.toString()}
                onChange={this.handleCityChange}
                name={question._id.toString()}
                selectValue={String(params[question._id])}
                options={citiesByCountry[params[86]]}
                wrapClass="form-select pbs"
                placeholder={get(translations, 'txt: Izvēlēties', 'Izvēlēties')}
              />
            </div>
          </div>
        );
      }

      return ('');
    };

    const renderQuestions = () => {
      const { questionsData: questionData } = this.state;
      let questions = false;
      if (typeof questionData.questions !== 'undefined') {
        questions = questionData.questions; // eslint-disable-line prefer-destructuring
      }

      if (questions !== false) {
        const questionsItems = [];
        Object.values(questions).forEach((question) => {
          const questionsAnswerItems = [];
          const questionId = question._id.toString();
          // console.log(question);
          if (question.type === 'checkbox' || questionId === '83') {
            Object.values(question.answers).forEach((answer) => {
              let answerChecked = false;
              // TODO šo vēl var paskatīties
              if (typeof params[questionId] !== 'undefined') {
                if (typeof params[questionId] === 'object') {
                  if (params[questionId].includes(answer._id)) {
                    answerChecked = true;
                  }
                } else if (params[questionId] === answer._id) {
                  answerChecked = true;
                }
              }

              let answerTitle = answer.title;

              if (typeof answer.translations.title[globals.locale] !== 'undefined') {
                answerTitle = answer.translations.title[globals.locale];
              }

              questionsAnswerItems.push( // eslint-disable-line function-paren-newline
                <Checkbox
                  key={answer._id}
                  id={answer._id}
                  label={answerTitle}
                  onChange={this.handleChange}
                  name={questionId}
                  value={answer._id}
                  checked={answerChecked}
                  labelClass="dib"
                  wrapClass="form-checkbox"
                />,
              ); // eslint-disable-line function-paren-newline
            });
          } else if (question.type === 'dropdown') {
            const options = [{ value: '', label: '-' }];
            Object.values(question.answers).forEach((answer) => {
              options.push({ key: answer._id, value: answer._id, label: answer.title });
            });

            questionsAnswerItems.push( // eslint-disable-line function-paren-newline
              <Select1
                key={question._id}
                id={questionId}
                onChange={this.handleChange}
                name={questionId}
                selectValue={String(params[questionId])}
                options={options}
                wrapClass="form-select pbs"
              />,
            ); // eslint-disable-line function-paren-newline
          } else if (question._id === 88) {
            questionsItems.push(renderCityQuestion(question));
          }

          if (questionsAnswerItems.length > 0) {
            questionsItems.push( // eslint-disable-line function-paren-newline
              <div
                className={`lock block--line pts pbs${question._id === 82 || (type === 'matches' && type !== 'side') ? '' : ' searchParams-resp'}`}
                key={question._id}
              >
                <div className="searchParams-label">{question.title}</div>
                <div>{questionsAnswerItems}</div>
              </div>,
            ); // eslint-disable-line function-paren-newline
          }
        });

        return (<div>{questionsItems}</div>);
      }

      return ('');
    };

    const renderAdditionalQuestions = () => {
      const additionalQuestionsItems = [];
      const { questionsData: questionData } = this.state;
      let questions = false;
      const options = [{ value: '', label: '-' }];
      if (typeof questionData.additional_questions !== 'undefined') {
        questions = questionData.additional_questions; // eslint-disable-line prefer-destructuring
      }

      Object.values(questions).forEach((question) => {
        options.push({ key: question._id, value: question._id, label: question.title });
        const additionalQuestionsAnswerItems = [];
        const questionId = question._id.toString();
        Object.values(question.answers).forEach((answer) => {
          let answerChecked = false;
          // TODO šo vēl var paskatīties
          if (typeof params[questionId] !== 'undefined') {
            if (typeof params[questionId] === 'object') {
              if (params[questionId].includes(answer._id)) {
                answerChecked = true;
              }
            } else if (params[questionId] === answer._id) {
              answerChecked = true;
            }
          }

          let answerTitle = answer.title;
          if (typeof answer.translations.title[globals.locale] !== 'undefined') {
            answerTitle = answer.translations.title[globals.locale];
          }

          additionalQuestionsAnswerItems.push( // eslint-disable-line function-paren-newline
            <Checkbox
              key={answer._id}
              id={answer._id}
              label={answerTitle}
              onChange={this.handleAdditionalQuestionValueChange}
              name={questionId}
              value={answer._id}
              checked={answerChecked}
              labelClass="dib"
              wrapClass="form-checkbox"
            />,
          ); // eslint-disable-line function-paren-newline
        });
        additionalQuestionsItems.push( // eslint-disable-line function-paren-newline
          <div
            className={cx([
              'additionalQuestion block block--line mts',
              ['is-hidden', typeof additionalQuestionVisibility[questionId] === 'undefined' || additionalQuestionVisibility[questionId] === false],
            ])}
            key={question._id}
          >
            <div className="additionalQuestion-title pbs twb">{question.title}</div>
            <span
              className="additionalQuestion-close"
              role="presentation"
              onClick={() => this.setHideAdditionalQuestion(question._id)}
            >
              <ImageSvg svg="icon-close" iconClass="icon icon--close" />
            </span>
            <div>{additionalQuestionsAnswerItems}</div>
          </div>,
        ); // eslint-disable-line function-paren-newline
      });

      return (
        <div className={`mts${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`}>
          <div>
            <span className="searchParams-label">{translations['txt: Papildu kritēriji']}</span>
            <Select1
              id="additional_questions"
              name="additional_questions"
              options={options}
              onChange={this.handleAdditionalQuestionChange}
              wrapClass="form-select"
            />
          </div>
          {additionalQuestionsItems}
        </div>
      );
    };

    const renderAdminQuestions = () => {
      if (type !== 'admin') {
        return ('');
      }

      const adminQuestionsItems = [];
      const textFields = {
        email: 'txt: E-pasts',
        v2_data_id: 'txt: Vecais ID',
        draugiem_id: 'txt: Draugiem ID',
        facebook_id: 'txt: Facebook ID',
        gplus_id: 'txt: Google+',
        mailee_id: 'txt: Mailee ID',
        vk_id: 'txt: VK ID',
        itunes_id: 'txt: Itunes maks. id',
        phone: 'txt: Tālruņa nr.',
        ip: 'txt: IP adrese',
        ip_history: 'txt: IP vēsture',
        ip_range: 'txt: IP diapazons',
      };
      Object.keys(textFields).forEach((fieldName) => {
        adminQuestionsItems.push( // eslint-disable-line function-paren-newline
          <label key={fieldName} htmlFor={fieldName}>
            <span className="searchParams-label">{`${translations[textFields[fieldName]]}:`}</span>
            <Input
              value={typeof params[fieldName] !== 'undefined' ? params[fieldName] : ''}
              id={fieldName}
              className="form-control"
              name={fieldName}
              doneTyping={this.handleChange}
            />
          </label>,
        ); // eslint-disable-line function-paren-newline
      });

      // Days for birthday
      const days = [{ value: '', label: '-' }];
      for (let d = 1; d < 32; d += 1) {
        days.push({ value: d, label: d });
      }
      // Months for birthday
      const monthNames = [
        'janvāris',
        'februāris',
        'marts',
        'aprīlis',
        'maijs',
        'jūnijs',
        'jūlijs',
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris',
      ];
      const months = [{ value: '', label: '-' }];
      for (let m = 0; m < monthNames.length; m += 1) {
        months.push({ value: (m + 1), label: translations[monthNames[m]].substr(0, 3) });
      }
      // Years for birthday
      const years = [{ value: '', label: '-' }];
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      for (let y = (currentYear - 18); y > (currentYear - 120); y -= 1) {
        years.push({ value: y, label: y });
      }
      // Birthday
      adminQuestionsItems.push( // eslint-disable-line function-paren-newline
        <label key="birthday">
          <span className="searchParams-label">{`${translations['txt: Dzimšanas datums']}:`}</span>
          <div>
            <Select1
              key="birth_day"
              id="birth_day"
              onChange={this.handleChange}
              name="birth_day"
              selectValue={typeof params.birth_day !== 'undefined' ? params.birth_day : ''}
              options={days}
              wrapClass="form-select pbs"
              selectClass="form-control tsl"
            />
            <Select1
              key="birth_month"
              id="birth_month"
              onChange={this.handleChange}
              name="birth_month"
              selectValue={typeof params.birth_month !== 'undefined' ? params.birth_month : ''}
              options={months}
              wrapClass="form-select pbs"
              selectClass="form-control tsl"
            />
            <Select1
              key="birth_year"
              id="birth_year"
              onChange={this.handleChange}
              name="birth_year"
              selectValue={typeof params.birth_year !== 'undefined' ? params.birth_year : ''}
              options={years}
              wrapClass="form-select pbs"
              selectClass="form-control tsl"
            />
          </div>
        </label>,
      ); // eslint-disable-line function-paren-newline

      //
      const statusOptions = [{ value: '', label: '-' }];
      if (typeof globals.availableStatuses !== 'undefined') {
        Object.values(globals.availableStatuses).forEach((status) => {
          statusOptions.push({ value: status, label: status });
        });
      }

      //
      adminQuestionsItems.push(
        <label key="status">
          <span className="searchParams-label">{`${translations['txt: Statuss']}:`}</span>
          <div>
            <Select1
              key="status"
              id="status"
              onChange={this.handleChange}
              name="status"
              selectValue={typeof params.status !== 'undefined' ? params.status : ''}
              options={statusOptions}
              wrapClass="form-select pbs"
              selectClass="form-control tsl"
            />
          </div>
        </label>,
      );

      return (<div className="form-group mbm">{adminQuestionsItems}</div>);
    };

    return (
      <div id="searchSideContainer" className={`${type !== 'matches' && type !== 'side' ? 'searchSideContainer-resp' : ''}`}>

        {(type !== 'matches' || this.state.formVisible || !this.isMobile) ? (
          <div className="searchParamsHeader">
            <span className="searchParamsHeader-title">{type === 'matches' ? 'Filtrs' : translations['txt: Meklēšana']}</span>
            <div className="dib fr">
              {this.state.formVisible === true ? (
                <button type="button" className="searchParamsHeader-removeParams" onClick={this.toggleFormVisibility}>
                  <ImageSvg svg="icon-close" iconClass="icon icon--close" />
                  {' Aizvērt'}
                </button>
              ) : (
                <button type="button" className="searchParamsHeader-removeParams" onClick={this.removeParams}>
                  <ImageSvg svg="icon-close" iconClass="icon icon--close" />
                  {` ${translations['txt: Notīrīt']}`}
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="searchParamsHeader">
            <button type="button" className="searchParamsHeader-removeParams" onClick={this.toggleFormVisibility}>
              Atvērt filtru
            </button>
          </div>
        )}

        {(type !== 'matches' || this.state.formVisible || !this.isMobile) && (

        <form ref={this.searchForm} onSubmit={this.submitForm} className="searchParamsForm">
          {renderAdminQuestions()}
          <div className="form-group mbs searchParams-sex g-b pas">
            <div className="g-b g-b--1of2 tac">
              <Checkbox
                id="Sex.F"
                label={translations['txt: Sieviete']}
                onChange={this.handleChange}
                name="sex"
                value="F"
                checked={(params.sex.indexOf('F') !== -1)}
                labelClass="dib"
                wrapClass="form-checkbox"
              />
            </div>
            <div className="g-b g-b--1of2 tac">
              <Checkbox
                id="Sex.M"
                label={translations['txt: Vīrietis']}
                onChange={this.handleChange}
                name="sex"
                value="M"
                checked={(params.sex.indexOf('M') !== -1)}
                labelClass="dib"
                wrapClass="form-checkbox"
              />
            </div>
          </div>
          <div className="block">
            <label htmlFor="AgeMin">
              <span className="searchParams-label">{translations['txt: Vecums']}</span>
              <div>
                <Input
                  name="age_min"
                  label=""
                  value={params.age_min}
                  maxLength={3}
                  className="form-control--sw di"
                  id="AgeMin"
                  doneTyping={this.handleChange}
                />
                <span className="mls mrs">—</span>
                <Input
                  name="age_max"
                  label=""
                  value={params.age_max}
                  maxLength={3}
                  className="form-control--sw di"
                  id="AgeMax"
                  doneTyping={this.handleChange}
                />
              </div>
              <div className="mts">
                <InputRange
                  formatLabel={(value) => ''} // eslint-disable-line no-unused-vars
                  maxValue={120}
                  minValue={18}
                  value={{
                    min: params.age_min,
                    max: params.age_max,
                  }}
                  onChange={this.handleAgeRangeChange}
                  onChangeComplete={this.handleAgeRangeChangeComplete}
                />
              </div>
            </label>
            <div className={`mtm${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`}>
              <label htmlFor="OnlyIfPrefered">
                <Checkbox
                  id="OnlyIfPrefered"
                  label={translations['txt: only prefered']}
                  onChange={this.handleChange}
                  name="only_if_prefered"
                  checked={params.only_if_prefered}
                  value="1"
                  labelClass="dib"
                  wrapClass="form-checkbox"
                />
              </label>
            </div>
            <div className={`mts${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`}>
              <label htmlFor="OnlyIfPreferedSex">
                <Checkbox
                  id="OnlyIfPreferedSex"
                  label={translations['txt: only prefered sex']}
                  onChange={this.handleChange}
                  name="only_if_prefered_sex"
                  checked={params.only_if_prefered_sex}
                  value="1"
                  labelClass="dib"
                  wrapClass="form-checkbox"
                />
              </label>
            </div>
          </div>
          {showName && (
            <div className={`block mts${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`}>
              <label htmlFor="name">
                <span className="searchParams-label">{translations['txt: Vārds']}</span>
                <Input
                  value={typeof params.name !== 'undefined' ? params.name : ''}
                  id="name"
                  className="form-control"
                  name="name"
                  doneTyping={this.handleChange}
                />
              </label>
            </div>
          )}
          <div className={`block mts${type !== 'matches' && type !== 'side' ? ' searchParams-resp' : ''}`}>
            <label htmlFor="HeightMin">
              <span className="searchParams-label">{translations['txt: Augums (cm)']}</span>
              <div>
                <Input
                  name="height_min"
                  label=""
                  value={params.height_min}
                  maxLength={3}
                  className="form-control--sw di"
                  id="HeightMin"
                  doneTyping={this.handleChange}
                />
                <span className="mls mrs">—</span>
                <Input
                  name="height_max"
                  label=""
                  value={params.height_max}
                  maxLength={3}
                  className="form-control--sw di"
                  id="HeightMax"
                  doneTyping={this.handleChange}
                />
              </div>
              <div className="mts">
                <InputRange
                  maxValue={220}
                  minValue={0}
                  formatLabel={(value) => ''} // eslint-disable-line no-unused-vars
                  value={{
                    min: params.height_min,
                    max: params.height_max,
                  }}
                  onChange={this.handleHeightRangeChange}
                  onChangeComplete={this.handleHeightRangeChangeComplete}
                />
              </div>
            </label>
          </div>
          {renderQuestions()}
          {type !== 'matches' && type !== 'side' && (
            <div className="block mts searchParams-resp">
              <label htmlFor="WithPhoto">
                <span className="searchParams-label">{translations['txt: Lietotāji']}</span>
                <Checkbox
                  id="WithPhoto"
                  label={translations['txt: Ar fotogrāfiju']}
                  onChange={this.handleChange}
                  name="image"
                  checked={params.image}
                  value="1"
                  labelClass="dib"
                  wrapClass="form-checkbox"
                />
                {get(globals, 'hasVerification', false) && (
                  <Checkbox
                    id="Verified"
                    label={translations['txt: Verificēts profils']}
                    onChange={this.handleChange}
                    name="verified"
                    checked={params.verified}
                    value="1"
                    labelClass="dib"
                    wrapClass="form-checkbox"
                  />
                )}
                <Checkbox
                  id="NotVisited"
                  label={translations['txt: Neapskatīti']}
                  onChange={this.handleChange}
                  name="not_visited"
                  checked={params.not_visited}
                  value="1"
                  labelClass="dib"
                  wrapClass="form-checkbox"
                />
              </label>
            </div>
          )}
          {type !== 'matches' && type !== 'side' && renderAdditionalQuestions()}
        </form>
        )}
        {type !== 'matches' && type !== 'side' && (
          <div className="block mtm searchDetailsBtn">
            <div className="btn btn--c btn--block btn--iconLeft">
              <span>{translations['txt: Detalizētāk']}</span>
              <span className="btn-static">
                <span className="vcenter">
                  <span className="vcenter-inner">
                    <ImageSvg svg="icon-arrowdown" iconClass="icon icon--arrowDown" />
                    <ImageSvg svg="icon-arrowup" iconClass="icon icon--arrowUp" />
                  </span>
                </span>
              </span>
            </div>
          </div>
        )}
        {(type !== 'matches' || this.state.formVisible || !this.isMobile) && (
        <div className="block mtm searchSubmitBtn">
          <button onClick={this.submitForm} type="submit" className="btn btn--b btn--block btn--iconLeft">
            <span>{translations['txt: Meklēt']}</span>
            <span className="btn-static">
              <span className="vcenter">
                <span className="vcenter-inner">
                  <ImageSvg svg="icon-find" iconClass="icon  icon--find" />
                </span>
              </span>
            </span>
          </button>
        </div>
        )}
      </div>
    );
  }
}

SearchSideContainer.propTypes = {
  submitForm: PropTypes.func,
  showName: PropTypes.bool,
  type: PropTypes.string,
  submitSideForm: PropTypes.func,
  subType: PropTypes.string,
};

SearchSideContainer.defaultProps = {
  submitForm: null,
  showName: false,
  type: 'regular',
  submitSideForm: null,
  subType: null,
};

export default SearchSideContainer;
